import { SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { HelpOutlined } from '@mui/icons-material';
import { ResultItemRow } from './result-item-row.component';
import { convertHyphenated } from '../../../../../core/util/string-conversion';

/**
 * Renders a result whose `type` the UI doesn't recognise (e.g. a future server-added type), so a
 * new type degrades gracefully to label + subType instead of crashing.
 */
export function FallbackResultItem({
  item,
  href,
  onClick
}: {
  item: SearchResultItemDto;
  href?: string;
  onClick?: () => void;
}) {
  return (
    <ResultItemRow
      icon={<HelpOutlined />}
      primary={item.label}
      secondaryLines={[item.subType ? convertHyphenated(item.subType, { capitalizeEachWord: true }) : undefined]}
      href={href}
      onClick={onClick}
    />
  );
}
